<script setup>
  import imagePlaceholder from '@/assets/workspace-placeholder.png';

  const props = defineProps({
    workspace: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: '8rem',
    },
    classNames: {
      type: String,
      default: '',
    },
    useThumbnail: {
      type: Boolean,
      default: false,
    },
  });

  const image = computed(() => {
    if (props.useThumbnail) {
      return props.workspace.thumb;
    }
    return props.workspace?.image;
  });
</script>

<template>
  <v-img
    v-if="image"
    cover
    :class="{
      'tw-rounded-full': image,
      'tw-rounded-[8px]': !image,
      [classNames]: classNames.length > 0,
    }"
    :style="`width: ${size}; height: ${size};`"
    :src="image ?? imagePlaceholder"
    :lazy-src="image ?? imagePlaceholder"
    :alt="props.workspace?.name"
  />
</template>

<style scoped lang="css"></style>
